export const serverUrl = '/index/graphql';
export const serverRootUrl = '';
export const updateUrl = '/dealer/manager/graphql';
export const managerUrl = '/manager/manager/graphql';
export const callCenterUrl = '/manager/manager/call-graphql';
export const dealerLoginUrl = '/dealer/app-login';
export const mainTrackingId = 'UA-181601849-2';